import { Translations } from './types';

export const pt: Translations = {
  navbar: {
    home: 'Início',
    projects: 'Projetos',
  },
  home: {
    bio: (years) => [
      `Engenheiro de Software Sénior orientado a resultados, com mais de ${years} anos de experiência no desenvolvimento de aplicações web escaláveis e de fácil manutenção, utilizando React, Next.js, TypeScript e ecossistemas modernos de JavaScript. Historial comprovado na entrega de soluções de alta qualidade nos sectores de fintech, SaaS, viagens e educação, com especialização em desenvolvimento full-stack, arquitetura de sistemas e liderança técnica. Apaixonado por código limpo, otimização de desempenho e práticas de desenvolvimento modernas.`,
    ],
    aboutTitle: 'Sobre',
    aboutTitleAccent: 'Mim',
    about1: [
      'Tenho muito orgulho no meu compromisso com o artesanato de software, esforçando-me sempre por produzir código que não é apenas limpo e eficiente, mas que também respeita os princípios de não repetição (DRY) e padrões de design consistentes.',
      'Com formação em Análise Técnica de IT, a minha abordagem à resolução de problemas assenta no pragmatismo. Acredito em enfrentar desafios com uma compreensão aprofundada das restrições do mundo real, garantindo que as soluções que desenvolvo não são apenas teoricamente sólidas, mas também práticas e alinhadas com os requisitos do projeto.',
    ],
    experienceTitle: ['Marcas', 'com que trabalhei'],
  },
  aboutMe: {
    getInTouch: 'ENTRAR EM CONTACTO',
    messageSent: 'MENSAGEM ENVIADA',
    modalTitle: 'ENVIE-ME UMA MENSAGEM',
    firstName: 'Nome',
    lastName: 'Apelido',
    email: 'E-mail',
    subject: 'Assunto',
    cancel: 'Cancelar',
    submit: 'Enviar',
    errors: {
      firstName: 'Por favor, introduza o seu nome',
      lastName: 'Por favor, introduza o seu apelido',
      email: 'Por favor, introduza o seu e-mail',
      emailInvalid: 'Por favor, introduza um endereço de e-mail válido',
      subject: 'Por favor, introduza uma mensagem',
    },
  },
  projects: {
    bio: [
      'Projetos pessoais em que trabalhei durante o último ano ou mais.',
      'Fique à vontade para consultar os links do GitHub para os projetos listados.',
    ],
    reposTotal: 'Total de Repositórios Públicos no GitHub:',
    loading: 'A carregar projetos...',
    repositories: 'Repositórios',
    sortBy: 'Ordenar por:',
    newest: 'Mais recente',
    oldest: 'Mais antigo',
    sectionTitle: 'Projetos',
    sectionTitleAccent: 'Open source',
    noDescription: 'Sem descrição disponível.',
    created: 'Criado em:',
    githubButton: 'GitHub ↗',
  },
  companies: {
    orchahealth: {
      title: 'Orcha Health',
      intro:
        'Engenheiro de Software Sénior a trabalhar em toda a stack numa plataforma de saúde digital, com contribuições em melhorias de arquitetura frontend, design de API seguro e pipelines de CI/CD completos, utilizando Next.js, TypeScript, C#/.NET, Cypress, Storybook, MUI, SCSS, Docker e Azure DevOps.',
      highlights: [
        {
          title: 'Arquitetura da Biblioteca de Componentes',
          body: 'Decomposição de uma biblioteca de componentes de UI monolítica em seis pacotes com versões independentes: uma biblioteca Core UI partilhada de componentes primitivos e cinco bibliotecas específicas por domínio (Form UI, Widget UI, entre outras) — seguindo um padrão de dependência unidirecional. Melhoria do desempenho frontend em 30% e eliminação do acoplamento entre bibliotecas que estava a bloquear lançamentos independentes.',
        },
        {
          title: 'Hub de Fornecedores White-Label',
          body: 'Conceção e desenvolvimento de uma aplicação web white-label em Next.js/React/TypeScript com autenticação JWT, Controlo de Acesso Baseado em Funções (RBAC), obtenção de dados no lado do servidor, personalização de UI por fornecedor (esquemas de cores e logótipos) e acesso a produtos de avaliação de saúde na aplicação.',
        },
        {
          title: 'Segurança e Desempenho da API',
          body: 'Implementação de endpoints de API .NET seguros com limitação de taxa, validação de JWT e verificações de permissões granulares. Substituição de lógica de consulta ad-hoc por procedimentos armazenados otimizados e DTOs bem definidos, eliminando execução SQL redundante que estava a causar timeouts intermitentes sob tráfego elevado — melhorando a estabilidade da API e reduzindo custos de infraestrutura desnecessários.',
        },
        {
          title: 'Remediação de Segurança',
          body: 'Avaliação proativa de todas as aplicações frontend relativamente à vulnerabilidade Axios 1.14.1, mitigando o risco em frontends legados e modernos. Remediação de vulnerabilidades críticas em codebases Next.js 8 legados, incluindo configurações incorretas de cabeçalhos HTTP, exposição à cadeia de fornecimento npm e uma falha de Execução Remota de Código (RCE) em React, juntamente com uma auditoria completa de dependências.',
        },
        {
          title: 'Propriedade de CI/CD e Lançamentos',
          body: 'Gestão dos processos de lançamento frontend end-to-end em todas as aplicações de consumidor, criando pipelines Azure DevOps de raiz — incluindo configurações de build YAML multi-fase, Dockerfiles, templates de Helm charts e gestão de grupos de variáveis por ambiente — assegurando deployments rápidos, repetíveis e isolados por ambiente em dev, staging e produção.',
        },
      ],
    },
    natwest: {
      title: 'NatWest Rooster Money',
      intro:
        'Contribuição para o redesign completo da UI após a aquisição pelo NatWest, implementando novas funcionalidades e resolvendo erros na codebase React Cordova, alinhando a aplicação Rooster Money com a linguagem de design e os padrões de marca do NatWest, utilizando React, TypeScript, Redux Toolkit, SCSS e Framer Motion.',
      highlights: [
        {
          title: 'Redesign do Painel de Administração Legado',
          body: 'Liderança do redesign e reconstrução completa de um painel de administração legado, migrando de Handlebars, jQuery e Node.js 8 para uma arquitetura full-stack moderna com React, Redux, TypeScript, NestJS e PostgreSQL. Redução do tempo das operações de suporte ao cliente em 45% através de um desempenho de página significativamente mais rápido, routing seguro e controlo de acesso baseado em funções via autenticação por par de chaves JWT.',
        },
        {
          title: 'Tokenização Apple Pay e Google Pay',
          body: 'Liderança na implementação frontend da tokenização Apple Pay e Google Pay, juntamente com uma tabela de gestão de tokens paginada no lado do servidor — com capacidades de ordenação, suspensão, desvinculação e eliminação — reforçando a segurança das transações e a confiança dos clientes na plataforma.',
        },
        {
          title: 'Funcionalidade de Bloqueio de Comerciantes',
          body: 'Liderança no desenvolvimento frontend e backend de uma funcionalidade de bloqueio de comerciantes que permite aos pais bloquear pagamentos a categorias específicas de comerciantes. Desenvolvido com React, TypeScript e Next.js no frontend e endpoints RESTful Node.js no backend, com operações CRUD geridas via PostgreSQL. Apoio direto às obrigações de proteção do NatWest para titulares de contas infantis.',
        },
      ],
    },
    onefile: {
      title: 'OneFile',
      intro:
        'Responsável pelo desenvolvimento frontend de duas aplicações principais: a aplicação web de inscrição SSR Enrol, construída com React, Next.js, Redux Toolkit e Styled-Components; e uma aplicação de administração interna baseada em Angular. Contribuição para o backend ASP.NET Core / SQL Server com operações CRUD otimizadas para escalabilidade. A plataforma estava alojada na infraestrutura Microsoft Azure.',
      highlights: [
        {
          title: 'Principais Funcionalidades Entregues',
          body: 'Desenvolvimento de um construtor dinâmico de formulários web, exportação para PDF, importação CSV e autenticação de utilizadores. Criação de um sistema de design reutilizável em Styled-Components para garantir consistência de UI em toda a aplicação, juntamente com uma API RESTful Flask/Python para gestão de políticas de aprendizagem e regulamentações governamentais.',
        },
        {
          title: 'Testes e Qualidade',
          body: 'Manutenção de cobertura abrangente através de testes unitários, de integração e de snapshot, colaborando estreitamente com gestores de projeto, especialistas de QA e designers num enquadramento Scrum ágil.',
        },
        {
          title: 'Formação e Partilha de Conhecimento',
          body: 'Realização de sessões de formação internas sobre React hooks e CSS responsivo, com foco em técnicas de layout Flexbox e Grid.',
        },
      ],
    },
    tickiteline: {
      title: 'Ticketline',
      intro:
        'Liderança do desenvolvimento frontend de uma plataforma de revenda de bilhetes SSR greenfield, construída com React, Next.js, TypeScript, Redux e SCSS, com contribuições adicionais no backend via ASP.NET Core. A plataforma estava alojada na infraestrutura Microsoft Azure.',
      highlights: [
        {
          title: 'Arquitetura Frontend',
          body: 'Assunção da responsabilidade principal pela aplicação React SSR, arquitetando componentes reutilizáveis, incluindo um calendário, pesquisa de eventos com filtragem multifacetada e resultados paginados no lado do servidor — entregando aproximadamente 60% da funcionalidade da aplicação com 60% de cobertura de testes unitários.',
        },
        {
          title: 'Mentoria e Formação',
          body: 'Realização de sessões de formação internas sobre TypeScript, React SSR, HTML e técnicas avançadas de layout CSS, incluindo Flexbox e Grid, ajudando os colegas a alargar as suas competências e a elevar as suas contribuições para o projeto.',
        },
        {
          title: 'Ferramenta de Web Scraping',
          body: 'Desenvolvimento de uma ferramenta de extração de conteúdo utilizando Python, JavaScript, HTML e CSS para a equipa de marketing acompanhar preços da concorrência, atualizações de produtos e informações de mercado.',
        },
      ],
    },
    sabs: {
      title: 'SABS Travel Technologies',
      intro:
        'Papel fundamental no desenvolvimento da plataforma de reservas de viagens de negócios Lightning, utilizando Angular 14, TypeScript, RxJS, GraphQL, SCSS e Storybook, contribuindo para uma experiência fluida e responsiva para viajantes de negócios.',
      highlights: [
        {
          title: 'UI de Mapa de Assentos de Voo',
          body: 'Conceção e desenvolvimento de uma interface interativa de mapa de assentos que permite aos utilizadores selecionar lugares com atributos detalhados, como adequação para bebés e espaço para as pernas, simplificando o processo de reserva e melhorando a experiência geral do utilizador.',
        },
      ],
    },
    rhinogroup: {
      title: 'Rhino Group',
      intro: '',
      highlights: [
        {
          title: 'Ferramenta de Web Scraping',
          body: 'Desenvolvimento de uma ferramenta de extração de conteúdo utilizando Python, JavaScript, HTML e CSS, utilizada principalmente pela equipa de marketing para monitorizar preços da concorrência, atualizações de produtos e outras informações-chave de mercado.',
        },
        {
          title: 'Aplicação CMS Personalizada',
          body: 'Papel significativo na construção de um sistema de gestão de conteúdo (CMS) personalizado utilizando Angular, consumindo uma API RESTful construída com Laravel ligada a uma base de dados MySQL. A aplicação simplificou a criação interna de páginas de destino, proporcionando uma interface de utilizador intuitiva para produção rápida de páginas.',
        },
      ],
    },
  },
};
